<template>
    <div>
        <div class="product-list row grid" :class="{'home-cat-list__more--load': !mounted}" ref="productList">
            <div v-for="item in visibleItems" class="col-6 col-md-4 col-lg-3">
                <category-item :item-data="item.data" :key="item.id" />
            </div>
        </div>
        <div v-if="!lastPage && !is404" class="d-flex justify-content-center">
            <button class="home-highlight-items__btn"
                    :disabled="loading"
                    @click="updateVisibleItems(true)">
                <template v-if="loading">
                    {{ $translate('HoferAntikschmuck::Template.loadMoreLoading') }}
                </template>
                <template v-else>
                    {{ $translate('HoferAntikschmuck::Template.loadMoreItems') }}

					<svg stroke="currentColor">
						<use xlink:href="#chevron-down" />
					</svg>
                </template>
            </button>
        </div>
    </div>
</template>

<script>
import ApiService from 'ceres/app/services/ApiService';

export default {
    props: {
        categoryId: {
            required: true,
            type: Number
        },
        items: {
            type: Array,
            required: true
        },
        sorting: {
            type: String,
            default: ''
        },
        itemsPerPage: {
            type: Number,
            default: 15
        }
    },
    data() {
        return {
            itemList: [],
            visibleItems: [],
            loading: false,
            currentPage: 1,
            lastPage: false,
            mounted: false,
			wrapperHeight: 0,
			itemHeight: 0,
			is404: false,
        };
    },
    created() {
        this.itemList     = this.items;
        this.visibleItems = this.items;
    },
    mounted() {
        this.updateVisibleItems();
    },
    methods: {
        updateVisibleItems(clicked) {
			let productList = this.$refs.productList

			this.is404 = document.getElementsByTagName("body")[0].classList.contains("category-page-not-found")
			if(clicked){

				this.wrapperHeight = productList.clientHeight

				productList.style.height = this.wrapperHeight + "px"
				productList.classList.add("overflow-hidden")

				this.itemHeight = this.$refs.productList.getElementsByTagName("article")[0].clientHeight
			}

				let amount = 6;

				if(window.matchMedia('(min-width: 992px)').matches) {

					if(this.is404) {
						amount = 12;
					}
					else {
						amount = 15;
					}

				}

				else if(window.matchMedia('(min-width: 768px)').matches) {
					amount = 9;
				}


            /**
             * SSR CLS optimization
             *
             * All items are rendered on created and the responsive visibility is done with CSS max-height and
             * overflow hidden (CSS class "product-list__more--load"). On the server the document is not available.
             * When the component is mounted the correct amount is calculated with the viewPort and
             * set in visibleItems. The load class is removed in the template.
             */
            if(!this.mounted) {

                this.visibleItems = this.itemList.slice(0, amount);
                this.itemList.splice(0, amount);

                this.$nextTick(() => {
                    this.mounted = true;
                })

                return;

            }else {
                this.loading = true;
            }

            this.loadItems(amount).then((data) => {

                this.itemList     = this.itemList.concat(data);
                this.visibleItems = this.visibleItems.concat(this.itemList.slice(0, amount));

                this.itemList.splice(0, amount);

				productList.style.height = this.wrapperHeight + (this.itemHeight * 3) + "px"




				setTimeout(function(){
					productList.classList.remove("overflow-hidden")

					if (productList.style.removeProperty) {
						productList.style.removeProperty('height');
					} else {
						productList.style.removeAttribute('height');
					}
				}, 600);

				this.loading = false;

            }).catch(err => {
                console.error(err);
                this.loading = false;
            });
        },
        loadItems(amount) {

            return new Promise((resolve, reject) => {

                if(this.itemList.length < amount && !this.lastPage) {

                    ApiService.get(
                        window.location.origin + '/rest/io/category?items=' + this.itemsPerPage + '&sorting=' +
                        this.sorting + '&page=' + (++this.currentPage) + '&categoryId=' + this.categoryId
                    ).done(response => {

                        if(response.itemList.documents.length < 15) {
                            this.lastPage = true;
                        }

                        resolve(response.itemList.documents);

                    }).fail(error => {
                        reject(error);
                    });

                }else {
                    resolve([]);
                }
            });
        }
    },
};
</script>
